import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';

export interface ActionsMenuItem {
  id: string;
  name: string;
  icon?: string;
}

@Component({
  selector: 'md-actions-menu',
  templateUrl: 'actions-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsMenuComponent extends BaseComponent {
  @Input()
  items: ActionsMenuItem[] = [];

  @Output()
  itemClick = new EventEmitter<string>();

  constructor() {
    super();
  }
}
